import React, { Component } from "react";
import _ from "lodash";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Theme,
  createStyles,
  WithStyles,
  Grid,
  withStyles,
  Typography,
  CardContent,
  Card,
  Avatar,
  Menu,
  MenuItem,
  CardHeader,
  IconButton,
  Collapse,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Modal,
} from "@material-ui/core";
import { MoreVert as MoreIcon } from "@material-ui/icons";
import {
  MyPATIconButton,
  MyPATCollapse,
  MyPATDialog,
  MyPATTextField,
} from "../../common";
import GoalManagementHeader from "../components/GoalManagementHeader";
import AddGoalDialog from "../components/AddGoalDialog";
import GoalCard from "../components/GoalCard";
import { getGoalList, getNewGoalList } from "../actions/goalManagementActions";
import { GoalDescriptionBody } from "../types/GoalDescriptionBody";
import { copyFileSync } from "fs";
import CustomInfoIcon from "../../common/CustomInfoIcon";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { CloseOutlined as CloseIcon } from "@material-ui/icons";
import PerfectScrollbar from "react-perfect-scrollbar";
import TargetYear from "../components/TargetYear";
import Status from "../components/Status";
import AddCareerOptionDialog from "../components/AddCareerOptionDialog";
import Goal_Pagination from "../components/Goal_Pagination";
import goalManagementService from "../services/goalManagementService";
import MyPATNoDataPanel from "../../common/MyPATNoDataPanel";
import MyPATLandingContainer, {
  ChildProps,
} from "../../common/MyPATLandingContainer";
import ContentPagination from "../../mylibrary/components/ContentPagination";
import { GoalListItem } from "../types/GoalListItem";
import MyPATLandingFilterCard from "../../common/MyPATLandingFilterCard";
import GoalManagementFilter from "../components/GoalManagementFilter";
import GoalFilter from "./GoalFilter";
import { getRandomColor } from "../../../utils";

const styles = (theme: Theme) =>
  createStyles({
    sidebarContainer: {
      position: "relative",
      marginTop: 76,
    },
    noDataContainer: {
      width: "100%",
      height: "calc(100% - 30px)",
      padding: "0px 0px 0px 60px",
      "& .noDataCard": {
        height: "100%",
      },
    },
    searchContainer: {
      margin: "12px 0px",
      position: "relative",
      width: "394px !important",
      "& img": {
        top: 14,
        left: 16,
        width: 16,
        position: "absolute",
        marginRight: 10,
      },
      "& input": {
        lineHeight: "20px",
        padding: "12px 10px 10px 40px",
        fontSize: 16,
        borderRadius: 30,
        border: "0.5px solid rgb(223 223 223)",
        width: "100%",
        "&:focus": {
          outline: "none",
        },
        "&::-moz-placeholder": {
          /* Firefox 19+ */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&:-ms-input-placeholder": {
          /* IE 10+ */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&:-moz-placeholder": {
          /* Firefox 18- */
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
        },
        "&::placeholder": {
          color: "hsl(0deg 0% 65%)",
          fontWeight: "normal",
          fontSize: 14,
          opacity: 1,
          lineHeight: "16px",
        },
      },
    },
    marginTop12: {
      marginTop: 12,
    },
    epansionPanelBody: {
      padding: "0px 16px 8px",
      alignItems: "center",
    },
    expand: {
      transform: "rotate(0deg)",
      marginLeft: "auto",
      right: -6,
    },
    expandOpen: {
      transform: "rotate(180deg)",
    },
    cardHeader: {
      fontSize: "1rem",
      fontFamily: '"Nunito", sans-serif',
      color: "rgba(50, 60, 71, 1)",
      width: "100%",
      padding: "0px 16px 0px",
      "& h6": {
        fontWeight: 600,
        fontSize: 16,
        lineHeight: "22px",
        color: "#333333",
      },
    },
    customCard: {
      background: "#FFFFFF",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: 8,
      marginBottom: 12,
      cursor: "pointer",
    },
    mb2x: {
      margin: "8px 0px 0px",
    },
    infoIcon: {
      position: "relative",
      top: -2,
      "& second-child": {
        marginLeft: -105,
        top: 25,
      },
    },
    marginTop1x: {
      marginTop: 12,
    },
    cardTitle: {
      fontSize: "1rem",
      fontWeight: 600,
    },
    paddingRightMD: {
      padding: "0px 45px 0px 0px",
    },
    filterCard: {
      background: "rgb(255 255 255)",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: 8,
      width: '55vw'
    },
    cursorPointer: {
      cursor: "pointer",
      "& :hover": {
        color: "#417dea",
      },
    },
    tooltipDetails: {
      position: "absolute",
      marginTop: 40,
      zIndex: 999999,
    },
    scrollBarX: {
      display: "flex",
      padding: "0px 10px 0px 4px",
      alignItems: "center",
      paddingBottom: "0px !important",
      "& .scrollbar-container": {
        width: "100%",
        overflowX: "auto",
        padding: 0,
      },
    },
    modal: {
      display: "flex",
      padding: 12,
      alignItems: "center",
      justifyContent: "center",
    },
    filter: {
      fontSize: "1rem",
      fontFamily: '"Roboto", sans-serif',
      color: "rgba(50, 60, 71, 1)",
      width: "100%",
      padding: "0px 10px 0px 15px",
    },
    borderBlue: {
      color: "#1D7DEA !important",
      border: "1px solid #1D7DEA",
      fontSize: "0.875rem",
    },
    addFilterWrapper: {
      display: "flex",
      justifyContent: "center",
      padding: 10,
    },
    root: {
      justifyContent: "center",
      display: "block",
    },
    icon: {
      width: 16,
      height: 16,
      boxShadow:
        "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
      "$root.Mui-focusVisible &": {
        outline: "2px auto rgba(19,124,189,.6)",
        outlineOffset: 2,
      },
      "input:hover ~ &": {
        backgroundColor: "#ebf1f5",
      },
      "input:disabled ~ &": {
        boxShadow: "none",
        background: "rgba(206,217,224,.5)",
      },
    },
    checkedIcon: {
      backgroundColor: "rgb(29 125 234)",
      backgroundImage:
        "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
      "&:before": {
        display: "block",
        width: 16,
        height: 16,
        backgroundImage:
          "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
          " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
          "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
      },
      "input:hover ~ &": {
        backgroundColor: "#106ba3",
      },
    },
    formControlLabel: {
      fontSize: 16,
      color: "#333333",
    },
    formLabelRoot: {
      marginLeft: 0,
    },

    checkbox: {
      padding: theme.spacing.unit / 4,
      top: 0,
      left: 4,
      width: 20,
      height: 20,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      backgroundColor: "#fff",
      border: "1px solid #979797",
      borderRadius: 2,
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: "Nunito",
        fill: "#979797",
        opacity: 0,
      },
    },
    checkedCheckbox: {
      backgroundColor: "#1d7dea",
      border: "1px solid #1d7dea",
      borderRadius: 2,
      color: "#99a1a7",
      "&::after": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
      "&:hover": {
        backgroundColor: "#1d7dea",
      },
    },

    primaryColor: {
      color: "rgb(29 125 234)",
    },
    addMoreFilterHeader: {
      textAlign: 'center',
      border: '1px solid #e6e6e6'
    },
    addMoreFilterTitle: {
      fontWeight: 600,
      fontSize: '28px'
    },
    iconButton: {
      padding: '10px 10px',
      opacity: 0.5,
      fontSize: theme.spacing.unit * 3,
      position: 'absolute',
      right: 0,
      top: -4,
      '& svg': {
        fontSize: 30
      }
    },
  });

interface GoalManagementContainerProps extends WithStyles<typeof styles> {
  getGoalList: () => void;
  goalManagementList: GoalDescriptionBody[];
  history: any;
  getNewGoalList: () => void;
  onChange: Function;
}

interface Filters {
  [filterKey: string]: {
    values?: any;
    isMultiple?: boolean;
    name: string;
    allOptions?: { name: string; value: string }[];
  };
}

interface GoalManagementContainerState {
  expandedFilter: boolean;
  expandedStatusCard: boolean;
  expandedYearCard: boolean;
  goalDialogOpen: boolean;
  dialogData: any;
  actionType: string;
  years: string[];
  statusExpandIcon: boolean;
  yearExpandIcon: boolean;
  isCheckedStatus: boolean;
  isCheckedYear: boolean;
  careerOptionDialogOpen: boolean;
  addGoalCategory: boolean;
  filters: Filters;
  loading: boolean;
  totalResults: number;
  addAnotherFilter: boolean;
}

export const GOAL_ACTION_TYPE_CONST = {
  ADD_NEW_GOAL: "addNewGoal",
  EDIT_VERSION: "editVersion",
  ADD_NEW_VERSION: "addNewVersion",
  DELETE_VERSION: "deleteVersion",
  EDIT_GOAL: "editGoal",
  DUPLICATE_GOAL: "duplicateGoal",
  READ_ONLY: "readOnly",
};

const PAGE_SIZE = 20;

class GoalManagementContainer extends Component<
  GoalManagementContainerProps,
  GoalManagementContainerState
> {
  landingContainerRef:any
  constructor(props: GoalManagementContainerProps) {
    super(props);
    this.state = {
      expandedFilter: true,
      expandedStatusCard: true,
      expandedYearCard: true,
      goalDialogOpen: false,
      dialogData: {},
      actionType: "",
      years: [],
      statusExpandIcon: false,
      yearExpandIcon: false,
      isCheckedStatus: false,
      isCheckedYear: false,
      careerOptionDialogOpen: false,
      addGoalCategory: false,
      filters: {},
      loading: false,
      totalResults: 0,
      addAnotherFilter: false,
    };

    this.handleAddGoalDialogOpen = this.handleAddGoalDialogOpen.bind(this);
    this.handleAddGoalDialogClose = this.handleAddGoalDialogClose.bind(this);
    this.redirectToDeletedGoals = this.redirectToDeletedGoals.bind(this);
    //@ts-ignore
    this.landingContainerRef = React.createRef();
  }

  getYear() {
    let { years } = this.state;
    let currentYear = new Date().getFullYear();
    for (let i = currentYear - 5; i <= currentYear + 7; i++) {
      years.push(i.toString());
    }
    this.setState({ years });
  }
  toggleCareerOptionDialogOpen = () => {
    this.setState((prevState) => ({
      ...prevState,
      careerOptionDialogOpen: !prevState.careerOptionDialogOpen,
    }));
  };

  setFilters(filters: any) {
    if (!_.isEmpty(this.state.filters)) {
      return;
    }
    const restructedFilters = Object.entries(filters).reduce(
      (acc: Filters, [filterKey, { data, name }]: [string, any]) => {
        acc[filterKey] = {
          isMultiple: true,
          values: [],
          name,
          allOptions: data,
        };
        return acc;
      },
      {}
    );
    this.setState({ filters: restructedFilters });
  }

  fetchGoalDescription = async (courseId: string) => {
    try {
      const course = await goalManagementService.getCourseDetails(courseId);
      return course;
    } catch (error) {
      console.log(error);
      return {};
    }
  };

  fetchGoalList = (params: any): Promise<GoalListItem> => {
    const {
      pagination,
      currentPageNo,
      pageSize,
      searchQuery,
      filters,
    } = params;
    const newParams: any = {};
    if (pagination) {
      newParams.pageNumber = currentPageNo;
      newParams.pageSize = pageSize;
    }
    if (searchQuery && searchQuery.length >= 3) {
      newParams.searchQuery = searchQuery;
    }
    if (filters) {
      Object.entries(filters).forEach(
        ([filterKey, { values }]: [string, any]) => {
          const newFilterKey = filterKey === "year" ? "years" : filterKey;
          if (values) {
            if (Array.isArray(values) && !_.isEmpty(values)) {
              newParams[newFilterKey] = values.toString();
            } else {
              newParams[newFilterKey] = values;
            }
          }
        }
      );
    }
    this.setState({ loading: true });
    return goalManagementService
      .goalList(newParams)
      .then((res: any) => {
        const { courseTypes, filter, totalResults } = res;
        this.setState({ loading: false });
        if (totalResults) {
          this.setState({ totalResults });
        }
        this.setFilters(filter);
        return courseTypes;
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
        return [];
      });
  };

  handleAddGoalDialogOpen = async (e: any, id: string) => {
    try {
      e.stopPropagation();
      let { dialogData, years, actionType } = this.state;

      dialogData["getCurrentYear"] = years;
      if (id) {
        let data = await this.fetchGoalDescription(id);
        if (!_.isUndefined(data)) {
          dialogData = {
            id: data._id,
            goalName: data.name,
            groupId: data.groupId,
            goalTypeName: data.courseType.name,
          };
        }
      }
      this.setState({
        goalDialogOpen: true,
        dialogData,
        actionType: GOAL_ACTION_TYPE_CONST.ADD_NEW_GOAL,
      });
    } catch (error) {
      console.log(error);
    }
  };

  handleOpenDialogWithData = async (
    dialogData: any,
    goalId: any,
    actionType: string
  ) => {
    let { years } = this.state;
    let dialogDataObj: any = await this.fetchGoalDescription(goalId);
    dialogDataObj['courseData'] = (dialogData.courses || [])
    // Coverting courseType id to a populated object
    if (!_.isEmpty(dialogDataObj)) {
      (dialogDataObj.courseType || {}).id = {
        _id: (dialogDataObj.courseType || {}).id,
        shortCode: dialogData.shortCode || "",
      };
      dialogDataObj.courseType.courseImage = dialogData.image;
      dialogDataObj.courseType.businessTypes = dialogData.businessTypes;
      dialogDataObj.courseType.pastClasses = dialogData.pastClasses;
      dialogDataObj.swotVisibility = dialogData.swotVisibility
    }
    const dialogDataYearsList = _.map((dialogData.courses || []), 'targetYear');
    //If year is already present do not show them it in frontend
    if (dialogDataYearsList && dialogDataYearsList.length) {
      dialogDataObj["getCurrentYear"] = _.difference(years, dialogDataYearsList);
    } else {
      dialogDataObj["getCurrentYear"] = years;
    }

    // dialogDataObj["getCurrentYear"] = years;

    // dialogDataObj = {
    //   ...dialogDataObj,
    // }

    return this.setState({
      goalDialogOpen: true,
      dialogData: dialogDataObj,
      actionType,
    });
  };

  componentDidMount() {
    // this.props.getGoalList();
    // this.props.getNewGoalList();
    this.getYear();
    goalManagementService.goalList("").then((res:any)=>{
     // console.log(res.courseTypes);
      // this.setState({
      //   goalList:res.courseTypes
      // })
    })
  }

  componentWillReceiveProps() {
    // setTimeout(this.initGoalLits.bind(this), 100);
  }

  // initGoalLits() {
  //   let { goalManagementList } = this.props;
  //   let { goalList } = this.state;
  //   if (!_.isEmpty(goalManagementList)) {
  //     let tempGoal: any = _.groupBy(goalManagementList, 'groupId');
  //     let targetYear: any = [];
  //     let className: any = [];
  //     goalList = [];

  //     Object.keys(tempGoal).forEach((goalL: any, i: number) => {
  //       //If no group is present then it will map to null as a key.
  //       //Since we are intrested in only zero index change target year
  //       if (!['null', 'undefined'].includes(goalL)) {

  //         //Will get all target year and map to it on first object only
  //         if (tempGoal[goalL] && tempGoal[goalL].length > 0) {
  //           targetYear = tempGoal[goalL].map((g: any) => {
  //             return {
  //               targetYear: g.targetYear.toString(),
  //               _id: g._id,
  //               status: g.status
  //             }
  //           });
  //           let latestGoalYear = Math.max.apply(null, targetYear.map(function (item: any) {
  //             return item.targetYear;
  //           })).toString();
  //           let latestGoalId = _.get(targetYear.find((goal: any) => {
  //             return goal.targetYear === latestGoalYear;
  //           }), '_id');
  //           tempGoal[goalL][0]['latestGoalId'] = latestGoalId;
  //           tempGoal[goalL][0]["targetYear"] = targetYear;

  //           //Will loop over all class at single time

  //           className = tempGoal[goalL].map((goal: any) => goal["class"] && goal["class"].length > 0 ? goal["class"].map((g: any) => g.name) : []);
  //           className = className.length > 0 ? className.flat("Infinity") : [];
  //           //Take unique name
  //           className = Array.from(new Set(className));
  //           tempGoal[goalL][0]["className"] = className;
  //           className = [];
  //           goalList.push(tempGoal[goalL][0]);

  //         }
  //       }
  //       else {
  //         goalList = [...goalList, ...tempGoal[goalL]];
  //       }
  //     })
  //     this.setState({ goalList });
  //   }
  // }

  handleAddGoalDialogClose = () => {
    if(this.landingContainerRef.current && this.landingContainerRef.current.handleChange){
      this.landingContainerRef.current.handleChange();
    }
    return this.setState({
      goalDialogOpen: false,
      dialogData: {},
      actionType: "",
    });
  };

  redirectToDeletedGoals = () => {
    let { history } = this.props;
    history.push("/goal-management/deleted");
  };

  setActionType = (type: string) => {
    this.setState({
      actionType: type,
    });
  };
  statusTooltipHover = () => {
    this.setState({
      statusExpandIcon: !this.state.statusExpandIcon,
    });
  };

  yearTooltipHover = () => {
    this.setState({
      yearExpandIcon: !this.state.yearExpandIcon,
    });
  };

  goalStatusList = () => {
    const { classes } = this.props;
    const { isCheckedStatus } = this.state;
    return (
      <>
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                onChange={(event: any) => {
                  this.onCheckedStatus(event);
                }}
                checked={isCheckedStatus}
                classes={{
                  root: classes.root,
                  colorPrimary: classes.primaryColor,
                }}
                disableRipple
                color="default"
                checkedIcon={
                  <span
                    className={[classes.icon, classes.checkedIcon].join(" ")}
                  />
                }
                icon={<span className={classes.icon} />}
                name="alterStatus"
              />
            }
            classes={{
              label: classes.formControlLabel,
              root: classes.formLabelRoot,
            }}
            label={<span className="labelText">Published</span>}
          />
        </FormGroup>
      </>
    );
  };

  statusCard = () => {
    const { classes } = this.props;

    const { expandedFilter } = this.state;
    return (
      <>
        <Card classes={{ root: classes.customCard }} elevation={0}>
          <CardHeader
            action={
              <>
                <div className={classes.marginTop12}>
                  <IconButton
                    className={[
                      classes.expand,
                      {
                        [classes.expandOpen]: !expandedFilter,
                      },
                    ].join(" ")}
                    onClick={(e) => this.filterExpandClick(e)}
                    aria-expanded={true}
                    aria-label="show more"
                  >
                    <ExpandMoreIcon fontSize="small" height="1.5em" />
                  </IconButton>
                </div>
              </>
            }
            title={
              <Typography component="h6" variant="body1">
                Date
              </Typography>
            }
            className={classes.cardHeader}
          />
          <Collapse
            in={expandedFilter}
            classes={{ container: classes.epansionPanelBody }}
            timeout="auto"
            unmountOnExit
          >
            {this.goalStatusList()}
          </Collapse>
        </Card>
      </>
    );
  };

  filterExpandClick = (value: any) => {
    this.setState({
      expandedFilter: !this.state.expandedFilter,
    });
    value.stopPropagation();
  };

  onCheckedStatus = (event: any) => {
    const { name, checked } = event.target;
    this.setState({ isCheckedStatus: !this.state.isCheckedStatus });
  };

  onCheckedYear = (event: any) => {
    const { name, checked } = event.target;
    this.setState({ isCheckedYear: !this.state.isCheckedYear });
  };

  handleStatusChange = (options: string) => {
    this.props.onChange("Status", options);
  };
  handleYearChange = (options: string) => {
    this.props.onChange("year", options);
  };
  closeAddAnotherFilterDialog = () => {
    this.setState({
      addAnotherFilter: false,
    });
  };
  renderAnotherFilter = ({
    filters,
    handleFilterChange,
  }: {
    filters: ChildProps["filters"];
    handleFilterChange: ChildProps["handleFilterChange"];
  }) => {
    const { classes } = this.props;

    return (
      <Grid>
        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          open={true}
          onClose={this.closeAddAnotherFilterDialog}
          aria-labelledby="server-modal-title"
          aria-describedby="server-modal-description"
          className={classes.modal}
          
        >
          <div className={classes.filterCard}>
            <Card className={classes.root}>
              <CardHeader
                action={
                  <IconButton
                    aria-label="settings"
                    onClick={this.closeAddAnotherFilterDialog}
                  >
                    <CloseIcon fontSize="large" />
                  </IconButton>
                }
                classes={{ root: classes.addMoreFilterHeader, title: classes.addMoreFilterTitle }}
                title="Filter"
              />
              <GoalFilter
                filters={filters}
                handleFilterChange={handleFilterChange}
                onClose={this.closeAddAnotherFilterDialog}
              />
            </Card>
          </div>
        </Modal>
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;

    const {
      goalDialogOpen,
      dialogData,
      // goalList,
      years,
      actionType,
      careerOptionDialogOpen,
      loading,
      filters,
      totalResults,
      addAnotherFilter,
    } = this.state;
    const goalId = _.get(dialogData, "courseType.id._id", "");
    const goalIdSet = new Set();
    return (
      <>
        <Grid container>
          <Grid item xs={12} className={classes.mb2x}>
            <GoalManagementHeader
              redirectToDeletedGoals={this.redirectToDeletedGoals.bind(this)}
              addGoalClickHandler={this.handleAddGoalDialogOpen.bind(this)}
              history={this.props.history}
              handleActionType={this.setActionType}
              careerOptionClickHandler={this.toggleCareerOptionDialogOpen}
            />
          </Grid>
          <MyPATLandingContainer
          ref={this.landingContainerRef}
            loading={loading}
            fetchAllData={this.fetchGoalList}
            filters={filters}
            pageSize={PAGE_SIZE}
          >
            {({
              loading,
              filters,
              data,
              searchQuery,
              onSearchQueryChange,
              currentPageNo,
              handleFilterChange,
              onPageChange,
              handleSearchClose
            }) => {
              return (
                <>
                  <Grid xs={3}>
                    <Grid className={classes.sidebarContainer}>
                      <GoalManagementFilter
                        filters={filters}
                        onChange={handleFilterChange}
                      />

                      <Grid
                        id="add-filter-button"
                        item
                        xs={12}
                        className={classes.addFilterWrapper}
                      >
                        <Button
                          className={classes.borderBlue}
                          onClick={() =>
                            this.setState({
                              addAnotherFilter: !this.state.addAnotherFilter,
                            })
                          }
                        >
                          Add another filter
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={9}>
                    <Grid className={classes.noDataContainer}>
                      <Grid
                        container
                        spacing={16}
                        justify="space-between"
                        alignItems="center"
                      >
                        <Grid item>
                          <Grid className={classes.searchContainer}>
                            <img src="/assets/svg/contentRequest/search-icon.svg" />
                            <input
                              type="text"
                              value={searchQuery}
                              onClick={(event: any) => {
                                event.stopPropagation();
                              }}
                              onChange={(event: any) => {
                                onSearchQueryChange(event.target.value);
                              }}
                              onKeyPress={(event: any) => {
                                onSearchQueryChange(event.target.value);
                              }}
                              placeholder="Search"
                            />
                            {searchQuery && (
                              <IconButton onClick={(e: any) => { e.target.value = ""; handleSearchClose(e); }} className={classes.iconButton}>
                                <CloseIcon />
                              </IconButton>
                            )}
                          </Grid>
                        </Grid>
                        <Grid item>
                          <Grid item>
                            <Grid style={{ textAlign: "right" }}>
                              <ContentPagination
                                page={currentPageNo}
                                count={totalResults}
                                rowsPerPage={PAGE_SIZE}
                                onChangePage={(e: any, page: number) => {
                                  onPageChange(page);
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container alignItems="center">
                        {_.map(data, (d: GoalListItem, i: number) => {
                          const initial = d.name.slice(0,2)
                          let duplicateColor = "";
                          let duplicateBackgroundColor = "";
                          const isDuplicateIntial = goalIdSet.has(initial);
                          if(!isDuplicateIntial){
                            goalIdSet.add(initial)
                          }else{
                            duplicateColor = getRandomColor(i);
                            duplicateBackgroundColor =getRandomColor(i+4);
                          }
                          
                          return (
                            <Grid key={i} item xs={12} sm={12} md={12}>
                            <GoalCard
                              history={this.props.history}
                              data={d}
                              handleOpenDialogWithData={
                                this.handleOpenDialogWithData
                              }
                              addGoalClickHandler={(e: any, id: string) =>
                                this.handleAddGoalDialogOpen(e, id)
                              }
                              years={years}
                              handleActionType={this.setActionType}
                              duplicateColor={duplicateColor}
                              duplicateBackgroundColor={duplicateBackgroundColor}
                              />
                          </Grid>
                     
                          )
                        }
                          
                          )}
                      </Grid>
                      {(!data || data.length === 0) && (
                        <Grid container className="noDataCard">
                          <MyPATNoDataPanel
                            imageURL="/assets/svg/goalManagement/noDataFound.svg"
                            heading="No results found!"
                            subPara="There were no results matching the keywords you have entered"
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  {addAnotherFilter &&
                    this.renderAnotherFilter({ filters, handleFilterChange })}
                </>
              );
            }}
          </MyPATLandingContainer>
        </Grid>

        {goalDialogOpen && (
          <AddGoalDialog
            isDialogOpen={goalDialogOpen}
            history={this.props.history}
            dialogCloseHandler={this.handleAddGoalDialogClose.bind(this)}
            dialogData={dialogData}
            actionType={actionType}
            goalId={goalId}
          />
        )}
        <AddCareerOptionDialog
          isDialogOpen={careerOptionDialogOpen}
          dialogCloseHandler={this.toggleCareerOptionDialogOpen}
        />
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  goalManagementList: _.get(state, "goalManagement.goalManagement.list", []),
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getGoalList,
      getNewGoalList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(GoalManagementContainer));
